import { V as VividElement, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { H as HostSemantics, a as applyHostSemantics } from './host-semantics.js';

class TabPanel extends HostSemantics(VividElement) {
}

const TabPanelTemplate = html`
	<template slot="tabpanel" ${applyHostSemantics({ role: "tabpanel" })}>
		<slot></slot>
	</template>
`;

const tabPanelDefinition = defineVividComponent(
  "tab-panel",
  TabPanel,
  TabPanelTemplate,
  [],
  {}
);
const registerTabPanel = createRegisterFunction(tabPanelDefinition);

export { TabPanel as T, registerTabPanel as r, tabPanelDefinition as t };
